import React from 'react';

interface HtmlStringRendererProps {
  content: string;
  className?: string;
  fallbackComponent?: keyof React.JSX.IntrinsicElements;
  style?: React.CSSProperties;
}

export const HtmlStringRenderer: React.FC<HtmlStringRendererProps> = ({
  content,
  className = '',
  fallbackComponent = 'div',
  style = {},
}) => {
  // Check if the string contains HTML-like content
  const containsHtml = /<[^>]*>/g.test(content);

  if (containsHtml) {
    // If it contains HTML, render it using dangerouslySetInnerHTML
    const Component = fallbackComponent as React.ElementType;
    // Add a class that removes margins from all child elements
    // This is because the RTE will add stuff as like a p tag for example
    // then the apps "base styles" will add huge margins to the P tags, etc. and it breaks everything
    // this is therefore effectively a normalising step
    const htmlClassName = `${className} [&>*]:m-0`.trim();
    return <Component className={htmlClassName} dangerouslySetInnerHTML={{ __html: content }} style={style} />;
  } else {
    // If it's plain text, render it normally
    const Component = fallbackComponent as React.ElementType;
    return <Component className={className} style={style}>{content}</Component>;
  }
};
